<template>
	<div class="page">
		<div class="page-title bg-white padding-lr flex justify-between align-center shadow-warp border-bottom">
			<div class="text-lg text-bold">
				<i class="el-icon-caret-right"></i>
				{{ $route.meta.title }}
			</div>
		</div>
		<div class="page-main">
			<div class="padding-xl bg-white shadow-warp">
				<el-form ref="formAdd" :model="formAdd" label-width="150px" label-suffix=":">
					<el-form-item label="名称" prop="name" :rules="{ required: true, message: '请输入产品名称', trigger: 'blur' }">
						<el-input v-model="formAdd.name" placeholder="请输入产品名称" autocomplete="off" style="width: 220px;"></el-input>
					</el-form-item>
					<el-form-item label="类型" prop="type" :rules="{ required: true, message: '请输入产品名称', trigger: 'blur' }">
						<el-select v-model="formAdd.type" placeholder="请选择">
							<el-option :value="1" label="一次性服务"></el-option>
							<el-option :value="2" label="长期服务"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="分类" prop="parentid">
						<el-cascader
							v-model="formAdd.parentid"
							placeholder="为空则为未分类"
							clearable
							:options="categoryList"
							:props="{ emitPath: false, checkStrictly: true, value: 'id', label: 'name' }"
						></el-cascader>
					</el-form-item>
					<el-form-item label="状态"><el-switch v-model="formAdd.stateflag" :active-value="1" :inactive-value="0" active-color="#13ce66"></el-switch></el-form-item>
					<el-form-item label="备注">
						<el-input type="textarea" placeholder="请输入内容" v-model="formAdd.remark" maxlength="140" show-word-limit rows="5" :style="{ width: '600px' }"></el-input>
					</el-form-item>
					<el-divider content-position="left">表单设计</el-divider>
					<el-button @click="addFormItem">
						<i class="el-icon-plus"></i>
						<span>添加控件</span>
					</el-button>
					<el-row :gutter="50">
						<el-col :span="14">
							<fieldset class="shadow shadow-lg">
								<legend class="padding">表单预览</legend>
								<el-form ref="orderForm" :model="orderForm" label-width="120px" label-suffix=":" v-if="formAdd.orderform.length > 0" class="padding-lr">
									<div v-for="(item, index) in formAdd.orderform" :key="item.key" class="flex justify-between align-center border-bottom padding-top">
										<el-form-item :prop="item.key" :label="item.name">
											<el-input
												v-model="orderForm[item.key]"
												:placeholder="item.config.placeholder"
												:clearable="item.config.clearable"
												:show-word-limit="item.config.showWordLimit"
												:maxlength="item.config.maxlength ? item.config.maxlength : false"
												:minlength="item.config.minlength ? item.config.minlength : false"
												:style="{ width: item.config.width }"
												v-if="item.type == 'input'"
											></el-input>
											<form-item-input-array v-model="orderForm[item.key]" :config="item.config" v-if="item.type == 'inputArray'"></form-item-input-array>
											<el-input
												type="textarea"
												v-model="orderForm[item.key]"
												:placeholder="item.config.placeholder"
												:clearable="item.config.clearable"
												:show-word-limit="item.config.showWordLimit"
												:maxlength="item.config.maxlength ? item.config.maxlength : false"
												:minlength="item.config.minlength ? item.config.minlength : false"
												:rows="item.config.rows"
												:style="{ width: item.config.width }"
												v-if="item.type == 'textarea'"
											></el-input>
											<el-input-number
												v-model="orderForm[item.key]"
												:placeholder="item.config.placeholder"
												:max="item.config.max"
												:min="item.config.min"
												:step="item.config.step"
												:step-strictly="item.config.stepStrictly"
												:precision="item.config.precision"
												:controls="item.config.controls"
												v-if="item.type == 'inputNumber'"
											></el-input-number>
											<el-radio-group v-model="orderForm[item.key]" v-if="item.type == 'radio'">
												<template v-if="item.config.type == 'radio'">
													<el-radio :label="val" :border="item.config.border" v-for="(val, idx) in item.config.values" :key="idx"></el-radio>
												</template>
												<template v-if="item.config.type == 'button'">
													<el-radio-button
														:label="val"
														:border="item.config.border"
														v-for="(val, idx) in item.config.values"
														:key="idx"
													></el-radio-button>
												</template>
											</el-radio-group>
											<el-checkbox-group
												v-model="orderForm[item.key]"
												:min="item.config.min"
												:max="item.config.max ? item.config.max : 99"
												v-if="item.type == 'checkbox'"
											>
												<el-checkbox :label="val" :border="item.config.border" v-for="(val, idx) in item.config.values" :key="idx">{{ val }}</el-checkbox>
											</el-checkbox-group>
											<el-select v-model="orderForm[item.key]" v-if="item.type == 'select'">
												<el-option :value="val" v-for="(val, idx) in item.config.values" :key="idx">{{ val }}</el-option>
											</el-select>
											<el-select
												v-model="orderForm[item.key]"
												multiple
												:collapse-tags="item.config.collapseTags"
												:multipleLimit="item.config.multipleLimit"
												v-if="item.type == 'selectMultiple'"
											>
												<el-option :value="val" v-for="(val, idx) in item.config.values" :key="idx">{{ val }}</el-option>
											</el-select>
											<form-item-region v-model="orderForm[item.key]" :config="item.config" v-if="item.type == 'region'"></form-item-region>
											<el-switch
												v-model="orderForm[item.key]"
												:inactive-value="item.config.inactiveValue"
												:active-value="item.config.activeValue"
												:active-color="item.config.activeColor"
												:inactive-color="item.config.inactiveColor"
												v-if="item.type == 'switch'"
											></el-switch>
											<el-date-picker
												v-model="orderForm[item.key]"
												:type="item.config.type"
												:format="item.config.format"
												:value-format="item.config.format"
												placeholder="请选择"
												v-if="item.type == 'datePicker' || item.type == 'datePickerRange'"
											></el-date-picker>
											<form-item-customer v-model="orderForm[item.key]" :multiple="item.config.multiple" v-if="item.type == 'customer'"></form-item-customer>
											<form-item-employee v-model="orderForm[item.key]" :multiple="item.config.multiple" v-if="item.type == 'employee'"></form-item-employee>
										</el-form-item>
										<div class="text-right" style="width: 200px;">
											<el-button size="mini" type="text" class="text-orange" @click="modifyFormItem(index)">
												<i class="el-icon-edit"></i>
												<span>修改</span>
											</el-button>
											<el-button size="mini" type="text" class="text-gray" @click="deleteFormItem(index)">
												<i class="el-icon-delete"></i>
												<span>删除</span>
											</el-button>
										</div>
									</div>
								</el-form>
								<div class="padding-xl text-center text-grey" v-else>
									<i class="el-icon-info"></i>
									请添加控件。
								</div>
							</fieldset>
						</el-col>
						<el-col :span="10">
							<fieldset class="shadow shadow-lg">
								<legend class="padding">表单结果</legend>
								<el-form label-width="120px" label-suffix=":" v-if="formAdd.orderform.length > 0" class="padding-lr">
									<el-form-item :prop="item.key" :label="item.name" v-for="(item, index) in formAdd.orderform" :key="item.key">
										<span>{{ orderForm[item.key] }}</span>
									</el-form-item>
								</el-form>
								<div class="padding-xl text-center text-grey" v-else>
									<i class="el-icon-info"></i>
									请添加控件。
								</div>
							</fieldset>
						</el-col>
					</el-row>
					<el-divider content-position="left"></el-divider>
					<el-form-item>
						<el-button type="primary" @click="formSubmitAdd">提 交</el-button>
						<el-button @click="dialogAdd = false">取 消</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<el-dialog :visible.sync="dialogVisibleFormItem" :show-close="false" append-to-body top="10vh" width="600px">
			<div slot="title" class="flex align-center justify-between">
				<div class="flex align-center">
					<span class="el-icon-folder-opened text-gray text-xxl"></span>
					<div class="margin-left-xs"><div class="text-bold">添加控件</div></div>
				</div>
				<el-link :underline="false" type="info" @click="dialogVisibleFormItem = false"><i class="el-icon-close text-xxl"></i></el-link>
			</div>
			<div class="padding-top-xl" v-loading="loadingFormItem">
				<el-form ref="formFormItem" :model="formFormItem" label-width="120px" label-suffix=":">
					<div class="padding-lr" style="max-height: 50vh; overflow: auto;">
						<el-form-item prop="key" label="控件KEY" :rules="{ required: true, message: '请输入KEY', trigger: 'blur' }">
							<el-input v-model="formFormItem.key" placeholder="KEY,不能重复" style="width: 220px;" v-if="formFormItem.action == 'add'"></el-input>
							<span class="text-bold" v-else>{{ formFormItem.key }}</span>
						</el-form-item>
						<el-form-item prop="name" label="控件名称" :rules="{ required: true, message: '请输入控件名称', trigger: 'blur' }">
							<el-input v-model="formFormItem.name" placeholder="控件名称" style="width: 220px;"></el-input>
						</el-form-item>
						<el-form-item prop="type" label="控件类型" :rules="{ required: true, message: '请选择控件类型', trigger: 'blur' }">
							<el-select v-model="formFormItem.type" @change="changeFormItemType">
								<el-option-group label="基础表单控件">
									<el-option label="文本输入框" value="input"></el-option>
									<el-option label="文本输入框组(列表)" value="inputArray"></el-option>
									<el-option label="文本输入域" value="textarea"></el-option>
									<el-option label="数字输入框" value="inputNumber"></el-option>
									<el-option label="单选框" value="radio"></el-option>
									<el-option label="多选框" value="checkbox"></el-option>
									<el-option label="下拉选择器" value="select"></el-option>
									<el-option label="下拉选择器(多选)" value="selectMultiple"></el-option>
									<el-option label="开关" value="switch"></el-option>
									<el-option label="地域选择器" value="region"></el-option>
									<el-option label="日期选择器" value="datePicker"></el-option>
									<el-option label="日期选择器(范围)" value="datePickerRange"></el-option>
									<el-option label="图片上传" value="uploadImage"></el-option>
									<el-option label="文件上传" value="uploadFile"></el-option>
								</el-option-group>
								<el-option-group label="业务组件">
									<el-option label="选择客户" value="customer"></el-option>
									<el-option label="选择联系人" value="contacter"></el-option>
									<el-option label="选择内部人员" value="employee"></el-option>
								</el-option-group>
							</el-select>
						</el-form-item>
						<el-divider content-position="left" class="margin-top-lg">控件配置</el-divider>
						<div v-if="formFormItem.type == 'input'">
							<el-form-item prop="config.value" label="默认值">
								<el-input v-model="formFormItem.config.value" placeholder="默认文本" style="width: 220px;"></el-input>
							</el-form-item>
							<el-form-item prop="placeholder" label="placeholder">
								<el-input v-model="formFormItem.config.placeholder" placeholder="placeholder" style="width: 220px;"></el-input>
							</el-form-item>
							<el-form-item prop="maxlength" label="最大输入长度">
								<el-input-number v-model="formFormItem.config.maxlength" :step="1" step-strictly></el-input-number>
							</el-form-item>
							<el-form-item prop="minlength" label="最小输入长度">
								<el-input-number v-model="formFormItem.config.minlength" :step="1" step-strictly></el-input-number>
							</el-form-item>
							<el-form-item prop="showWordLimit" label="字数统计"><el-switch v-model="formFormItem.config.showWordLimit"></el-switch></el-form-item>
							<el-form-item prop="clearable" label="可清空"><el-switch v-model="formFormItem.config.clearable"></el-switch></el-form-item>
							<el-form-item prop="width" label="文本框宽度">
								<el-input v-model="formFormItem.config.width" placeholder="默认宽度220px" style="width: 220px;"></el-input>
							</el-form-item>
						</div>
						<div v-if="formFormItem.type == 'inputArray'">
							<el-form-item prop="config.number" label="默认数量"><el-input-number :min="0" v-model="formFormItem.config.number"></el-input-number></el-form-item>
							<el-form-item prop="config.min" label="最小数量"><el-input-number :min="0" v-model="formFormItem.config.min"></el-input-number></el-form-item>
							<el-form-item prop="config.max" label="最大数量"><el-input-number :min="0" v-model="formFormItem.config.max"></el-input-number></el-form-item>
							<el-form-item prop="placeholder" label="placeholder">
								<el-input v-model="formFormItem.config.placeholder" placeholder="placeholder" style="width: 220px;"></el-input>
							</el-form-item>
							<el-form-item prop="maxlength" label="最大输入长度">
								<el-input-number v-model="formFormItem.config.maxlength" :step="1" step-strictly></el-input-number>
							</el-form-item>
							<el-form-item prop="minlength" label="最小输入长度">
								<el-input-number v-model="formFormItem.config.minlength" :step="1" step-strictly></el-input-number>
							</el-form-item>
							<el-form-item prop="showWordLimit" label="字数统计"><el-switch v-model="formFormItem.config.showWordLimit"></el-switch></el-form-item>
							<el-form-item prop="clearable" label="可清空"><el-switch v-model="formFormItem.config.clearable"></el-switch></el-form-item>
							<el-form-item prop="width" label="文本框宽度">
								<el-input v-model="formFormItem.config.width" placeholder="默认宽度220px" style="width: 220px;"></el-input>
							</el-form-item>
						</div>
						<div v-if="formFormItem.type == 'textarea'">
							<el-form-item prop="config.value" label="默认值">
								<el-input v-model="formFormItem.config.value" placeholder="默认文本" style="width: 220px;"></el-input>
							</el-form-item>
							<el-form-item prop="config.placeholder" label="placeholder">
								<el-input v-model="formFormItem.config.placeholder" placeholder="placeholder" style="width: 220px;"></el-input>
							</el-form-item>
							<el-form-item prop="config.maxlength" label="最大输入长度">
								<el-input-number v-model="formFormItem.config.maxlength" :step="1" step-strictly></el-input-number>
							</el-form-item>
							<el-form-item prop="config.minlength" label="最小输入长度">
								<el-input-number v-model="formFormItem.config.minlength" :step="1" step-strictly></el-input-number>
							</el-form-item>
							<el-form-item prop="config.showWordLimit" label="字数统计"><el-switch v-model="formFormItem.config.showWordLimit"></el-switch></el-form-item>
							<el-form-item prop="config.clearable" label="可清空"><el-switch v-model="formFormItem.config.clearable"></el-switch></el-form-item>
							<el-form-item prop="config.width" label="文本框宽度">
								<el-input v-model="formFormItem.config.width" placeholder="默认宽度220px" style="width: 220px;"></el-input>
							</el-form-item>
							<el-form-item prop="config.rows" label="行数">
								<el-input-number v-model="formFormItem.config.rows" :step="1" step-strictly></el-input-number>
							</el-form-item>
						</div>
						<div v-if="formFormItem.type == 'inputNumber'">
							<el-form-item prop="config.value" label="默认值"><el-input-number v-model="formFormItem.config.value"></el-input-number></el-form-item>
							<el-form-item prop="config.min" label="最小值"><el-input-number v-model="formFormItem.config.min"></el-input-number></el-form-item>
							<el-form-item prop="config.max" label="最大值"><el-input-number v-model="formFormItem.config.max"></el-input-number></el-form-item>
							<el-form-item prop="config.step" label="步长"><el-input-number v-model="formFormItem.config.step"></el-input-number></el-form-item>
							<el-form-item prop="config.stepStrictly" label="严格步长"><el-switch v-model="formFormItem.config.stepStrictly"></el-switch></el-form-item>
							<el-form-item prop="config.precision" label="数值精度"><el-input-number v-model="formFormItem.config.precision"></el-input-number></el-form-item>
							<el-form-item prop="config.controls" label="控制按钮"><el-switch v-model="formFormItem.config.controls"></el-switch></el-form-item>
						</div>
						<div v-if="formFormItem.type == 'radio'">
							<el-form-item prop="config.type" label="样式">
								<el-radio-group v-model="formFormItem.config.type">
									<el-radio label="radio">单选框</el-radio>
									<el-radio label="button">按钮</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item prop="config.border" label="显示边框"><el-switch v-model="formFormItem.config.border"></el-switch></el-form-item>
							<el-form-item prop="config.values" label="选项" :rules="{ required: true, message: '至少要有两个选项', trigger: 'blur' }">
								<div class="margin-bottom-xs" v-for="(val, idx) in formFormItem.config.values" :key="idx">
									<el-radio v-model="formFormItem.config.value" :style="{ marginRight: 0 }" :label="formFormItem.config.values[idx]"><i></i></el-radio>
									<el-input style="width: 180px;" placeholder="请输入" v-model="formFormItem.config.values[idx]" clearable></el-input>

									<el-button size="small" type="text" @click="$delete(formFormItem.config.values, idx)" class="margin-left-xs">
										<i class="el-icon-delete"></i>
										删除
									</el-button>
								</div>
								<el-button size="small" @click="formFormItem.config.values.push('')">
									<i class="el-icon-plus"></i>
									增加
								</el-button>
							</el-form-item>
						</div>
						<div v-if="formFormItem.type == 'checkbox'">
							<el-form-item prop="config.min" label="最少必选"><el-input-number v-model="formFormItem.config.min"></el-input-number></el-form-item>
							<el-form-item prop="config.max" label="最多可选"><el-input-number v-model="formFormItem.config.max"></el-input-number></el-form-item>
							<el-form-item prop="config.border" label="显示边框"><el-switch v-model="formFormItem.config.border"></el-switch></el-form-item>
							<el-form-item prop="config.values" label="选项" :rules="{ required: true, message: '至少要有两个选项', trigger: 'blur' }">
								<el-checkbox-group v-model="formFormItem.config.value">
									<div class="margin-bottom-xs" v-for="(val, idx) in formFormItem.config.values" :key="idx">
										<el-checkbox :label="formFormItem.config.values[idx]"><i></i></el-checkbox>
										<el-input style="width: 180px;" placeholder="请输入" v-model="formFormItem.config.values[idx]" clearable></el-input>
										<el-button size="small" type="text" @click="$delete(formFormItem.config.values, idx)" class="margin-left-xs">
											<i class="el-icon-delete"></i>
											删除
										</el-button>
									</div>
								</el-checkbox-group>
								<el-button size="small" @click="formFormItem.config.values.push('')">
									<i class="el-icon-plus"></i>
									增加
								</el-button>
							</el-form-item>
						</div>
						<div v-if="formFormItem.type == 'select'">
							<el-form-item prop="config.values" label="选项" :rules="{ required: true, message: '至少要有两个选项', trigger: 'blur' }">
								<div class="margin-bottom-xs" v-for="(val, idx) in formFormItem.config.values" :key="idx">
									<el-radio v-model="formFormItem.config.value" :style="{ marginRight: 0 }" :label="formFormItem.config.values[idx]"><i></i></el-radio>
									<el-input style="width: 180px;" placeholder="请输入" v-model="formFormItem.config.values[idx]" clearable></el-input>
									<el-button size="small" type="text" @click="$delete(formFormItem.config.values, idx)" class="margin-left-xs">
										<i class="el-icon-delete"></i>
										删除
									</el-button>
								</div>
								<el-button size="small" @click="formFormItem.config.values.push('')">
									<i class="el-icon-plus"></i>
									增加
								</el-button>
							</el-form-item>
						</div>
						<div v-if="formFormItem.type == 'selectMultiple'">
							<el-form-item prop="config.collapseTags" label="折叠标签"><el-switch v-model="formFormItem.config.collapseTags"></el-switch></el-form-item>
							<el-form-item prop="config.multipleLimit" label="最多可选">
								<el-input-number v-model="formFormItem.config.multipleLimit"></el-input-number>
							</el-form-item>
							<el-form-item prop="config.values" label="选项" :rules="{ required: true, message: '至少要有两个选项', trigger: 'blur' }">
								<el-checkbox-group v-model="formFormItem.config.value">
									<div class="margin-bottom-xs" v-for="(val, idx) in formFormItem.config.values" :key="idx">
										<el-checkbox :label="formFormItem.config.values[idx]"><i></i></el-checkbox>
										<el-input style="width: 180px;" placeholder="请输入" v-model="formFormItem.config.values[idx]" clearable></el-input>
										<el-button size="small" type="text" @click="$delete(formFormItem.config.values, idx)" class="margin-left-xs">
											<i class="el-icon-delete"></i>
											删除
										</el-button>
									</div>
								</el-checkbox-group>
								<el-button size="small" @click="formFormItem.config.values.push('')">
									<i class="el-icon-plus"></i>
									增加
								</el-button>
							</el-form-item>
						</div>
						<div v-if="formFormItem.type == 'region'">
							<el-form-item prop="config.showAllLevels" label="完整路径"><el-switch v-model="formFormItem.config.showAllLevels"></el-switch></el-form-item>
							<el-form-item prop="config.separator" label="分隔符	" :rules="{ required: true, message: '请填写选项分隔符	', trigger: 'blur' }">
								<el-input v-model="formFormItem.config.separator" placeholder="选项分隔符" style="width: 220px;"></el-input>
							</el-form-item>
							<el-form-item prop="config.emitPath" label="返回数组"><el-switch v-model="formFormItem.config.emitPath"></el-switch></el-form-item>
							<el-form-item prop="config.deep" label="数据深度">
								<el-select v-model="formFormItem.config.deep">
									<el-option :value="1" label="省"></el-option>
									<el-option :value="2" label="市"></el-option>
									<el-option :value="3" label="区/县"></el-option>
								</el-select>
							</el-form-item>
						</div>
						<div v-if="formFormItem.type == 'switch'">
							<el-form-item prop="config.value" label="默认状态">
								<el-switch
									v-model="formFormItem.config.value"
									:inactive-value="formFormItem.config.inactiveValue"
									:active-value="formFormItem.config.activeValue"
									:active-color="formFormItem.config.activeColor"
									:inactive-color="formFormItem.config.inactiveColor"
								></el-switch>
							</el-form-item>
							<el-form-item prop="config.activeValue" label="打开值" :rules="{ required: true, message: '请填写打开时的值', trigger: 'blur' }">
								<el-input v-model="formFormItem.config.activeValue" placeholder="打开时的值" style="width: 220px;"></el-input>
							</el-form-item>
							<el-form-item prop="config.inactiveValue" label="关闭值" :rules="{ required: true, message: '请填写关闭时的值', trigger: 'blur' }">
								<el-input v-model="formFormItem.config.inactiveValue" placeholder="关闭时的值" style="width: 220px;"></el-input>
							</el-form-item>
							<el-form-item prop="config.activeColor" label="打开颜色"><el-color-picker v-model="formFormItem.config.activeColor"></el-color-picker></el-form-item>
							<el-form-item prop="config.inactiveColor" label="关闭颜色">
								<el-color-picker v-model="formFormItem.config.inactiveColor"></el-color-picker>
							</el-form-item>
						</div>
						<div v-if="formFormItem.type == 'datePicker'">
							<el-form-item prop="config.value" label="默认值">
								<el-date-picker
									v-model="formFormItem.config.value"
									:type="formFormItem.config.type"
									:format="formFormItem.config.format"
									:value-format="formFormItem.config.format"
									placeholder="请选择"
								></el-date-picker>
							</el-form-item>
							<el-form-item prop="config.type" label="类型">
								<el-select v-model="formFormItem.config.type" placeholder="选择类型" style="width: 220px;">
									<el-option value="year" label="年"></el-option>
									<el-option value="month" label="月">月</el-option>
									<el-option value="week" label="周">周</el-option>
									<el-option value="date" label="日期">日期</el-option>
								</el-select>
							</el-form-item>
							<el-form-item prop="config.format" label="日期格式">
								<el-input v-model="formFormItem.config.format" placeholder="日期格式" style="width: 220px;"></el-input>
							</el-form-item>
						</div>
						<div v-if="formFormItem.type == 'datePickerRange'">
							<el-form-item prop="config.value" label="默认值">
								<el-date-picker
									v-model="formFormItem.config.value"
									:type="formFormItem.config.type"
									:format="formFormItem.config.format"
									:value-format="formFormItem.config.format"
									placeholder="请选择"
								></el-date-picker>
							</el-form-item>
							<el-form-item prop="config.type" label="类型">
								<el-select v-model="formFormItem.config.type" placeholder="选择类型" style="width: 220px;">
									<el-option value="daterange" label="日期范围">日期范围</el-option>
									<el-option value="monthrange" label="月份选择">月份选择</el-option>
								</el-select>
							</el-form-item>
							<el-form-item prop="config.format" label="日期格式">
								<el-input v-model="formFormItem.config.format" placeholder="日期格式" style="width: 220px;"></el-input>
							</el-form-item>
						</div>
						<div v-if="formFormItem.type == 'customer'">
							<el-form-item prop="config.multiple" label="是否多选"><el-switch v-model="formFormItem.config.multiple"></el-switch></el-form-item>
						</div>
						<div v-if="formFormItem.type == 'contacter'">
							<el-form-item prop="config.multiple" label="是否多选"><el-switch v-model="formFormItem.config.multiple"></el-switch></el-form-item>
						</div>
						<div v-if="formFormItem.type == 'employee'">
							<el-form-item prop="config.multiple" label="是否多选"><el-switch v-model="formFormItem.config.multiple"></el-switch></el-form-item>
						</div>
					</div>
					<el-divider></el-divider>
					<el-form-item label="">
						<el-button type="primary" @click="formSubmitFormItem">
							<i class="el-icon-s-promotion margin-right-xs"></i>
							提 交
						</el-button>
						<el-button @click="dialogVisibleFormItem = false">取 消</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import formItemInputArray from '@/components/form-item-input-array.vue';
import formItemRegion from '@/components/form-item-region.vue';
import formItemCustomer from '@/components/form-item-customer.vue';
import formItemEmployee from '@/components/form-item-employee.vue';
export default {
	components: { formItemInputArray,formItemRegion, formItemCustomer, formItemEmployee },
	data() {
		return {
			categoryList: [],
			formAdd: {
				name: '',
				type: 1,
				category: '0',
				stateflag: 1,
				orderform: []
			},
			dialogVisible: false,
			dialogVisibleFormItem: false,
			loadingFormItem: false,
			formFormItem: {
				action: 'add',
				key: '',
				name: '',
				value: '',
				type: '',
				config: {}
			},
			orderForm: {},
			formItemDefaultConfig: {
				input: {
					value: '',
					placeholder: '请输入',
					maxlength: 0,
					minlength: 0,
					showWordLimit: false,
					clearable: true,
					width: '220px'
				},
				inputArray: {
					value: [],
					min: 1,
					max: 10,
					number: 3,
					placeholder: '请输入',
					maxlength: 0,
					minlength: 0,
					showWordLimit: false,
					clearable: true,
					width: '220px'
				},
				textarea: {
					value: '',
					placeholder: '请输入',
					maxlength: 0,
					minlength: 0,
					showWordLimit: false,
					clearable: true,
					width: '220px',
					rows: 3
				},
				inputNumber: {
					value: 0,
					placeholder: '请输入',
					min: 0,
					max: 0,
					step: 1,
					stepStrictly: false,
					precision: 0,
					controls: true
				},
				radio: {
					value: '',
					type: 'radio',
					border: false,
					values: ['选项一', '选项二']
				},
				checkbox: {
					value: [],
					border: false,
					min: 0,
					max: 0,
					values: ['选项一', '选项二']
				},
				select: {
					value: [],
					values: ['选项一', '选项二']
				},
				selectMultiple: {
					value: [],
					collapseTags: false,
					multipleLimit: 0,
					values: ['选项一', '选项二']
				},
				region: {
					value: [],
					showAllLevels: true,
					separator: '-',
					emitPath: true,
					deep: 3
				},
				switch: {
					value: '',
					activeValue: '',
					inactiveValue: '',
					activeColor: '',
					inactiveColor: ''
				},
				datePicker: {
					value: '',
					type: 'date',
					format: 'yyyy-MM-dd'
				},
				datePickerRange: {
					value: [],
					type: 'daterange',
					format: 'yyyy-MM-dd'
				},
				customer: {
					multiple: false
				},
				contacter: {
					multiple: false
				},
				employee: {
					multiple: false
				}
			}
		};
	},
	beforecreate: function() {},
	created: function() {
		this.getCategoryList();
	},
	mounted: function() {},
	updated: function() {},
	methods: {
		getCategoryList() {
			this.loading = true;
			this.$http.post('/server/index.php?m=manager/product&a=getCategoryList', {}).then(
				res => {
					this.loading = false;
					if (res.result == 'ok') {
						this.categoryList = res.data;
					} else {
						this.$message.error(res.msg);
					}
				},
				err => {
					this.loading = false;
					if (err) {
						this.$alert('网络错误，指定的服务无法访问。', {
							title: '系统错误',
							type: 'error'
						});
					}
				}
			);
		},
		changeFormItemType(e) {
			this.formFormItem.config = Object.assign({}, JSON.parse(JSON.stringify(this.formItemDefaultConfig[e])));
		},
		addFormItem() {
			this.formFormItem = {
				action: 'add',
				key: '',
				name: '',
				type: '',
				config: {}
			};
			this.dialogVisibleFormItem = true;
		},
		modifyFormItem(index) {
			this.formFormItem = Object.assign({}, JSON.parse(JSON.stringify(this.formAdd.orderform[index])), { action: 'modify', index: index });
			this.dialogVisibleFormItem = true;
		},
		deleteFormItem(index) {
			this.$delete(this.formAdd.orderform, index);
		},
		formSubmitFormItem() {
			console.log(this.formFormItem)
			this.$refs['formFormItem'].validate(valid => {
				if (valid) {
					for (let i = 0; i < this.formAdd.orderform.length; i++) {
						if (this.formAdd.orderform[i].key == this.formFormItem.key || this.formAdd.orderform[i].name == this.formFormItem.name) {
							if (this.formFormItem.action == 'add') {
								this.$message.error('KEY或名称已存在！');
								return false;
							} else if (this.formFormItem.action == 'modify') {
								if (this.formFormItem.index != i) {
									this.$message.error('KEY或名称已存在！');
									return false;
								}
							}
						}
					}
					if (this.formFormItem.action == 'add') {
						this.$delete(this.formFormItem, 'action');
						this.formAdd.orderform.push(JSON.parse(JSON.stringify(this.formFormItem)));
						let orderForm = Object.assign({}, this.orderForm);
						orderForm[this.formFormItem.key] = this.formFormItem.config.value ? this.formFormItem.config.value : null;
						this.orderForm = Object.assign({}, orderForm);
						console.log(this.orderForm);
					} else if (this.formFormItem.action == 'modify') {
						let index = this.formFormItem.index;
						this.$delete(this.formFormItem, 'action');
						this.$delete(this.formFormItem, 'index');
						this.formAdd.orderform[index] = Object.assign({}, this.formFormItem);
					}
					this.dialogVisibleFormItem = false;
				} else {
					this.$message.error('请按提示填写');
				}
			});
		},
		formSubmitAdd() {
			console.log(this.formAdd);
			if (!this.formAdd.name) {
				this.$message.error('请填写产品名称');
				return false;
			}
			if (this.formAdd.orderform.length < 1) {
				this.$message.error('请设计订单表单');
				return false;
			}
			this.$refs['formAdd'].validate(valid => {
				if (valid) {
					const loading = this.$loading({
						lock: true,
						text: '处理中...',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					this.$http.post('/server/index.php?m=manager/product&a=add', this.formAdd).then(
						res => {
							loading.close();
							if (res.result == 'ok') {
								this.$alert('创建产品成功！', {
									title: '操作成功',
									type: 'success',
									callback: () => {
										this.$router.back(-1);
									}
								});
							} else {
								this.$alert(res.msg, {
									title: '操作错误',
									type: 'error'
								});
							}
						},
						err => {
							loading.close();
							if (err) {
								this.$alert('网络错误，指定的服务无法访问。', {
									title: '系统错误',
									type: 'error'
								});
							}
						}
					);
				} else {
					console.log('error submit!!');
				}
			});
			return false;
		}
	}
};
</script>

<style>
.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
.avatar-uploader .el-upload:hover {
	border-color: #409eff;
}
.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 178px;
	line-height: 178px;
	text-align: center;
}
.avatar {
	width: 178px;
	height: 178px;
	display: block;
}
.hide .el-upload--picture-card {
	display: none;
}

.product-item {
	cursor: pointer;
	border: #929181 2px dashed;
}
.product-item:hover {
	border-color: #409eff;
}
.product-item.active {
	border: #409eff 2px solid;
}
</style>
